import { ColumnsType } from 'antd/es/table';
import { ORDER_ACTIONS, ORDER_ID } from '@/config';
import useOrderColumnsStore, { selectHiddenColumns } from '@/stores/useOrderColumnsStore';
import type { ColumnOption } from '@/pages/orders/toolbar/ColumnsButton';

/** Without these a row cannot be identified or acted on, so they are never offered to hide. */
export const ALWAYS_SHOWN_COLUMNS: string[] = [ORDER_ID, ORDER_ACTIONS];

/** The tab's columns minus the ones the merchant hid, plus the list the Columns menu offers. */
export function useOrderTableColumns<T>(columns: ColumnsType<T>) {
  const hidden = useOrderColumnsStore(selectHiddenColumns);
  const keyOf = (c: ColumnsType<T>[number]) => String(c.key ?? '');

  const options: ColumnOption[] = columns
    .filter((c) => c.key !== undefined && !ALWAYS_SHOWN_COLUMNS.includes(keyOf(c)))
    .map((c) => ({ key: keyOf(c), label: typeof c.title === 'string' ? c.title : keyOf(c) }));
  const visible = columns.filter(
    (c) => ALWAYS_SHOWN_COLUMNS.includes(keyOf(c)) || !hidden.includes(keyOf(c)),
  );

  return { visible, options };
}
